import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Single chat-bubble row. Auto-styles based on role: user / assistant / system.
 * Assistant replies render Markdown (paragraphs, headings, lists, tables).
 */
export default function AIChatBubble({ role, text }) {
  const testId = role === "user" ? "ai-msg-user" : role === "system" ? "ai-msg-system" : "ai-msg-assistant";
  if (role === "user") {
    return (
      <div className="ml-auto max-w-[85%] bg-indigo-600 text-white px-4 py-2.5 rounded-2xl rounded-br-sm whitespace-pre-wrap text-[14.5px] leading-relaxed shadow-sm" data-testid={testId}>{text}</div>
    );
  }
  if (role === "system") {
    return (
      <div className="mx-auto max-w-[90%] bg-amber-50 text-amber-800 border border-amber-200 px-3 py-2 rounded-md text-[13px]" data-testid={testId}>{text}</div>
    );
  }
  return (
    <div className="mr-auto max-w-[92%] bg-white border border-slate-200 px-4 py-3 rounded-2xl rounded-bl-sm shadow-sm text-[14.5px] leading-relaxed text-slate-800 ai-md" data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text || ""}</ReactMarkdown>
    </div>
  );
}
